import React from 'react';
import { randomString } from '../../../store/utils';

export const PhotoGrid: React.FC<{
    isLoading?: boolean;
    photoLink?: string;
    onPhotoDeleteClick: () => void;
    onPhotoSubmit: (image: File) => void;
}> = ({ isLoading = false, photoLink, onPhotoDeleteClick, onPhotoSubmit }) => {
    const file_id = randomString(8);

    const onUploadClick = () => {
        if (isLoading) return;
        document.getElementById(`input_file_${file_id}`)?.click();
    };

    const onImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            onPhotoSubmit(e.target.files[0]);
        }
    };

    return (
        <div className="border rounded-8 border-darwin-neutral-100 flex justify-center items-center">
            <div className="object-fit-contain w-full">
                <div
                    className={`object-fit-contain relative flex flex-col justify-center items-center bg-darwin-neutral-50 h-150 rounded-8 cursor-pointer`}
                    onClick={onUploadClick}
                >
                    {isLoading ? (
                        <div className="h-full flex items-center justify-center">
                            <svg
                                className="w-24 h-24 fill-darwin-primary-500 animate-spin"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                            </svg>
                        </div>
                    ) : photoLink ? (
                        <img className="object-contain h-150" src={photoLink} />
                    ) : (
                        <>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                fill="currentColor"
                                className="w-18 h-18 text-darwin-accent-bright-blue-800"
                            >
                                <path d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z" />
                            </svg>
                            <div className="BodyBody1Bold text-darwin-accent-bright-blue-800">
                                Add Photos
                            </div>
                            <input
                                id={`input_file_${file_id}`}
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={onImageUpload}
                                hidden
                            />
                        </>
                    )}

                    {photoLink && (
                        <div
                            className="absolute -right-12 -top-12 p-6 rounded-full bg-darwin-neutral-100 shadow-elevation-900 cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                onPhotoDeleteClick();
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                                fill="currentColor"
                                className="w-16 h-16 text-darwin-neutral-1000"
                            >
                                <path d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z" />
                            </svg>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhotoGrid;
